export default __webpack_public_path__ + "static/media/package.2851b139.svg";